import React, {Component} from 'react';
import './PaiementWait.scss';
import {axiosInstance} from 'utils/auth.service';
import Conf from 'utils/Conf';
import CircularProgress from '@material-ui/core/CircularProgress';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import {Trans, withTranslation} from 'react-i18next';

const MAX_ATTEMPS = 10;

class PaiementWait extends Component {
  constructor(props) {
    super(props);
    this.nbAttempts = 0;
    this.ask = this.ask.bind(this);
    this.timeout = 0;
  }
  componentDidMount() {
    this.ask();
  }
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  ask() {
    const {appState, seance, onOk, onKo, i18n, onErreur} = this.props;
    const paymentMethod = localStorage.getItem('paymentMethod');
    console.log(paymentMethod);
    axiosInstance
      .get(`seances/${seance.seance_id}/payment/${paymentMethod}`, {
        params: {
          uuid: appState.uuid,
        },
        withCredentials: true,
      })
      .then(({data}) => {
        if (data.authorized || data.status === 'FULFILL') {
          onOk();
          this.nbAttempts = 0;
          localStorage.removeItem('paymentMethod');
        } else {
          if (data.payment_status === 'failed') {
            onKo();
          } else if (this.nbAttempts < MAX_ATTEMPS) {
            this.timeout = setTimeout(this.ask, 2000);
            this.nbAttempts++;
          } else {
            const erreur = (
              <Trans i18n={i18n} i18nKey="paiementwait-erreur" values={{email: Conf.contact_email}}>
                Votre paiement a bien été envoyé mais le serveur ne répond pas... Merci de nous contacter à l'adresse{' '}
                <strong>{{email: Conf.contact_email}}</strong>
                si vous ne recevez pas de confirmation par e-mail.
              </Trans>
            );
            onErreur(erreur);
          }
        }
        return null;
      });
  }
  render() {
    const {t} = this.props;
    return (
      <DialogContent>
        <DialogContentText>{t('traitement-en-cours')}</DialogContentText>
        <div className="spacer" />
        <div className="spacer" />
        <CircularProgress size="100px" />
        <div className="spacer" />
        <div className="spacer" />
      </DialogContent>
    );
  }
}
export default withTranslation()(PaiementWait);
